/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
window.autosize = require('autosize');
window.moment = require('moment');
require('moment/locale/ja');
window.Quill = require('quill');
window.QRCode = require('qrcode');

const mixin = require('./vue-mixin');
window.pointMixin = mixin.point;
window.paymentMixin = mixin.payment;
window.ajaxMixin = mixin.ajax;
window.richEditorMixin = mixin.richEditor;
window.announcementMixin = mixin.announcement;
window.pusherMixin = mixin.pusher;
window.soundMixin = mixin.sound;
window.breakpointMixin = mixin.breakpoint;
window.luxon = require('luxon');

require('./vue-component');
require('./vue-directive');

// 確認ダイアログを表示する : data-confirm="確認メッセージ"
$(document).on('click', '[data-confirm]', e => {

    const message = $(e.target).data('confirm');
    return confirm(message);

});

// クリップボードへコピーする : data-copy="#target-element"
$(document).on('click', '[data-copy]', e => {

    const target = $(e.target);
    const selector = target.data('copy');
    const inputElement = document.querySelector(selector);

    if(inputElement) {

        const copyingText = inputElement.value;
        inputElement.select();
        navigator.clipboard.writeText(copyingText);

        const originalButtonLabel = target.html();
        target.html('<i class="fa fa-check-circle"></i> コピー完了');

        setTimeout(() => {

            target.html(originalButtonLabel);

        }, 500);

    }

});